import React from 'react';
import { Link } from 'react-router-dom';
import { MountainIcon } from 'lucide-react';
const FORM_URL = 'https://api.leadconnectorhq.com/widget/form/8oL7mzyZiV6bC0aIfg98';
export function CampNavbar() {
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-brand-black/95 backdrop-blur-sm border-b border-brand-border" data-id="element-38">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-20 h-20 flex items-center justify-between" data-id="element-39">
        <Link to="/" className="flex items-center gap-3" data-id="element-40">
          <div className="w-10 h-10 bg-brand-grey rounded flex items-center justify-center border border-brand-border" data-id="element-41">
            <MountainIcon className="w-5 h-5 text-brand-accent" data-id="element-42" />
          </div>
          <div className="flex flex-col" data-id="element-43">
            <span className="font-heading font-bold text-base leading-none tracking-industrial text-brand-white uppercase" data-id="element-44">
              Banii bată-i vina
            </span>
            <span className="font-body text-xs text-brand-muted uppercase tracking-widest mt-1" data-id="element-45">
              Tabără 24–26 Iulie
            </span>
          </div>
        </Link>

        <a href={FORM_URL} className="hidden sm:inline-block bg-brand-accent text-brand-black font-heading font-bold uppercase text-sm tracking-industrial px-6 py-2.5 rounded-[4px] hover:bg-white transition-colors duration-300" data-id="element-46">
          Rezervă-ți locul
        </a>
      </div>
    </nav>;
}